import React from 'react'
import procureStyle from "./Procurement.module.css"
import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import InputBase from '@mui/material/InputBase';
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import Button from '@mui/material/Button'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FilterListIcon from '@mui/icons-material/FilterList';
import Modal from '@mui/material/Modal';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useEffect } from 'react';
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";



// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { ReportGmailerrorred } from '@mui/icons-material';
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'



const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 515,
    bgcolor: 'background.paper',
    border: '2px solid gray',
    boxShadow: '2px 2px 10px 2px gray',
    borderRadius: '5px',
    p: 4,
};







const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
                width: '20ch',
            },
        },
    },
}));

function Procurement() {

    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const token = useSelector((state) => state.globalData.token);
    const dispatch = useDispatch()
    const [filteredData, setFilteredData] = useState([])
    const [open, setOpen] = useState(false);

    const [selectedData, setSelectedData] = useState({})
    const handleOpen = (row) => {
        setOpen(true)
        setSelectedData(row)
    };
    const handleClose = () => setOpen(false);

    const [query, setQuery] = useState("");

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [rowCount, setRowCount] = useState(10);
    const [entryCount, setEntryCount] = useState("");



    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const [data, setData] = useState([])
    const [filterQuery, setFilterQuery] = useState("")

    // const [modalData,setModalData]=useState({

    // })

    
    const [clicked, setclicked] = useState(null);

    const [procureRole, setprocureRole] = React.useState("");

    const [view, setView] = useState(false)
    const handleView = (row) => {
        setView(true)
        console.log(row)
        setSelectedData(row)

    }
    const handleViewClose = () => setView(false)
    const handleprocureRoles = (event) => {
        setprocureRole(event.target.value);
    };


    const getProcureData = async () => {

        try {
            const res = await axios.get(
                `${process.env.REACT_APP_STEELADMIN}/superAdmin/getAllDetails`

            ).then((res) => {

                setData(res.data);

                console.log(res.data[0]?.kamEntity[0]?.approved)
            })

        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        let count = 0;
        data.forEach((tt) => {
            if (!tt?.approved && tt.requested) {
                count += 1;
            }
        })
        setEntryCount(count);
    }, [data])
    useEffect(() => {
        getProcureData();
    }, [])


    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    // const deleteProcuementId = async (id) => {
    //     try {
    //         const res = await axios.delete(
    //             `${process.env.REACT_APP_STEELADMIN}/tickets/deleteById/${screenshotId}`
    //         )
    //         dispatch(setNotificationCount({
    //             count: count + 1,
    //         }))
    //         alert('Delete Successful!')
    //         getProcureData();

    //     } catch (error) {
    //         console.log(error)
    //     }
    // }


    const handleProcureApproval = async (id) => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_STEELADMIN}/superAdmin/kamApproveRequest/${id}`,
                {},
                {
                  headers: {
                    'Authorization': `Bearer ${token}`,
                  }
                }
              ).then((response) => {
                if (response.status === 200) {
                  alert("Approval succeeded");
                } else {
                  // Handle other response status codes or errors here
                  alert("API not giving 200");
                }
              }).catch((error) => {
                // Handle network errors or other exceptions here
                alert("catched error");
                console.log(error)
              });

        } catch (error) {
            // console.log(error)
            // console.log("Err")
        }
    }
    useEffect(() => {
        getProcureData();
    }, [])




    useEffect(() => {
        // const fill = data.filter(row => row?.kamEntity[0]?.name.includes(procureRole)).reverse();
        // let count = 0;

        // fill.map((tt) => {
        //     if (!tt.approved && tt.requested) {
        //         count += 1;
        //     }
        // })
        setFilteredData(data)
        setRowCount(count)


    }, [procureRole, data])


    // console.log(filteredData);

    useEffect(() => {

        setPage(0);
    }, [data, query, filteredData])


    return (
        <>
            <Card sx={{ maxWidth: '95%', border: 'none', outline: 'none', boxShadow: 'none', mt: '3%' }}>
                <CardContent>
                    <Paper className={procureStyle.myboder}>
                        <TableContainer sx={{ maxHeight: 650 }}>
                            <div className={procureStyle.USerListBox1}>
                                <Box className={procureStyle.Box1}>
                                    <Typography variant='h5'>Pending Approval</Typography>
                                    {/* <Typography variant='h6'>{entryCount} entries</Typography> */}
                                </Box>
                            </div>
                            <div className={procureStyle.USerListBox2}>
                                <Box className={procureStyle.Box1}>
                                    <Search>
                                        <SearchIconWrapper>
                                            <SearchIcon sx={{ zIndex: '1', color: '#727374' }} />
                                        </SearchIconWrapper>
                                        <StyledInputBase
                                            placeholder="Search…"
                                            onChange={(e) => setQuery(e.target.value)}
                                            inputProps={{ 'aria-label': 'search' }}
                                            sx={{ width: '100%', color: '##121926', backgroundColor: '#F8FAFC', borderRadius: '10px', border: '1px solid #Bdbdbd' }}
                                        />
                                    </Search>
                                </Box>
                                <Box className={procureStyle.Box2}>
                                    Filter by
                                    <FormControl sx={{ m: 1, width: '200px' }}>
                                        <Select
                                            value={procureRole}
                                            onChange={handleprocureRoles}
                                            displayEmpty
                                            inputProps={{ "aria-label": "Without label" }}
                                            style={{ height: '5vh' }}
                                        >

                                            <MenuItem value="">All Roles</MenuItem>
                                            <MenuItem value='Corporate'>Corporate</MenuItem>
                                            <MenuItem value='Vendor'>Vendor</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>

                            </div>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow className={procureStyle.Mainhead}>
                                        <TableCell className={procureStyle.Tablehead}>User</TableCell>
                                        <TableCell className={procureStyle.Tablehead}>Phone Number</TableCell>
                                        <TableCell className={procureStyle.Tablehead}>Company name</TableCell>
                                        <TableCell className={procureStyle.Tablehead}>Apply for</TableCell>
                                        <TableCell className={procureStyle.Tablehead}>Submitted on</TableCell>
                                        <TableCell className={procureStyle.Tablehead}>Action</TableCell>


                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {filteredData
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row) => {
                                            const userData = row?.kamEntity[0];
                                            if (!userData?.approved) {
                                            // console.log(userData.approved)
                                            // console.log(selectedData.kamEntity[0]?.id)
                                           
                                            return (
                                                <TableRow className={procureStyle.MainRow} hover role="checkbox" tabIndex={-1} key={row?.userId} >
                                                    <TableCell className={procureStyle.Tablerow1}> {row?.kamName}<Box className={procureStyle.Email}>{userData?.email}</Box></TableCell>
                                                    <TableCell className={procureStyle.Tablerow}>{userData?.phoneNumber} </TableCell>
                                                    <TableCell className={procureStyle.Tablerow}>{row?.organisationName} </TableCell>
                                                    <TableCell className={procureStyle.Tablerow}>{userData?.appliedFor} </TableCell>
                                                    <TableCell className={procureStyle.Tablerow}>{userData?.dateCreated.split('T')[0]} </TableCell>
                                                    <TableCell className={procureStyle.Tablerow}>{row?.action}
                                                        <VisibilityOutlinedIcon className={procureStyle.Tableicon} onClick={() => handleView(row)} />

                                                        {/* <DeleteForeverOutlinedIcon className={procureStyle.Tableicon} style={{ marginLeft: '10%' }} onClick={() => deleteProcuementId(row.id)} /> */}
                                                        <DeleteForeverOutlinedIcon className={procureStyle.Tableicon} style={{ marginLeft: '10%' }} />
                                                    </TableCell>
                                                </TableRow>
                                            );
                                            }

                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15]}
                            component="div"
                            count={rowCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            style={{ paddingTop: '2%' }}
                        />
                    </Paper>
                </CardContent>
            </Card>
            <Modal
                open={view}
                onClose={handleViewClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"

                BackdropProps={{
                    timeout: 500,
                    style: { backgroundColor: '#454545', opacity: '30%' }
                }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }
                }

            >
                <Box sx={style} className={procureStyle.formStart}>


                    <form action='' method='' >

                        <Typography variant='h6'>{selectedData?.organisationName}</Typography>
                        <div>
                            <label>Email ID</label>

                            <input type='text' value={selectedData?.kamEntity && selectedData?.kamEntity[0]?.email} />

                        </div>
                        <div>
                            <label>Organization Name</label>

                            <input type='text' value={selectedData?.kamEntity && selectedData?.organisationName} />
                        </div>
                        <div>
                            <label>KAM Email ID</label>
                            <input type='text' value={selectedData?.kamEntity && selectedData?.kamEntity[0]?.email} />
                        </div>
                        <div>
                            <label>KAM Phone No.</label>
                            <input type='text' value={selectedData?.kamEntity && selectedData?.kamEntity[0]?.phoneNumber} />
                        </div>
                        <div>
                            <label>GST/VAt Details</label>
                            <input type='text' value={selectedData?.kamEntity && selectedData?.kamEntity[0]?.gstDetails} />
                        </div>
                        <div className={procureStyle.formStartbutton}>
                            <Button variant="contained">Decline</Button>
                            <Button variant="contained" type='button' onClick={() => handleProcureApproval(selectedData.kamEntity[0]?.id)} >Approve</Button>
                        </div>

                    </form>
                </Box>
            </Modal>
        </>
    );
}


export default Procurement
